(function () {
  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  // Mobile menu
  function setHeaderBottom() {
    var header = document.querySelector('.site-header');
    if (!header) return;
    var rect = header.getBoundingClientRect();
    document.documentElement.style.setProperty('--header-bottom', Math.max(rect.bottom, 0) + 'px');
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-menu-toggle]');
    if (toggle) {
      setHeaderBottom();
      var open = document.body.classList.toggle('menu-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    if (e.target.closest('.mobile-nav a')) {
      document.body.classList.remove('menu-open');
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.body.classList.contains('menu-open')) {
      document.body.classList.remove('menu-open');
      var t = document.querySelector('[data-menu-toggle]');
      if (t) { t.setAttribute('aria-expanded', 'false'); t.focus(); }
    }
  });

  // Reveal on scroll
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  // Sticky mobile CTA appears after scrolling past the hero
  function initMobileCta() {
    var cta = document.querySelector('.mobile-cta');
    if (!cta) return;
    var onScroll = function () {
      var nearBottom = window.innerHeight + window.scrollY > document.body.scrollHeight - 400;
      cta.classList.toggle('is-visible', window.scrollY > 500 && !nearBottom);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Events: auto-mark past events by date
  function initEvents(root) {
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    (root || document).querySelectorAll('[data-event-date]').forEach(function (el) {
      var d = new Date(el.getAttribute('data-event-date') + 'T23:59:59');
      if (!isNaN(d) && d < today) {
        el.classList.add('event--past');
        var hide = el.closest('[data-hide-past="true"]');
        if (hide) el.remove();
      }
    });
    (root || document).querySelectorAll('[data-hide-past="true"]').forEach(function (list) {
      if (!list.querySelector('.event')) {
        var empty = list.parentElement.querySelector('.events-empty');
        if (empty) empty.hidden = false;
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initMobileCta();
    initEvents();
    setHeaderBottom();
  });

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target);
    initEvents(e.target);
  });
})();
